'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = {
  wrapper: {
    width: '100%'
  },
  title: {
    color: '#252528',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontFamily: '"Gotham SSm A", "Gotham SSm B"'
  },
  hr: {
    width: '60px',
    margin: '30px auto 50px',
    border: 'none',
    height: '5px',
    color: '#0096FF',
    backgroundColor: '#0096FF'
  }
};

function SectionTitle(_ref) {
  var title = _ref.title,
      titleColor = _ref.titleColor,
      align = _ref.align,
      wrapperCustomStyle = _ref.wrapperCustomStyle;
  var titleCustomColor = titleColor ? {
    color: titleColor
  } : {};
  var hrAlign = align ? {
    "float": align
  } : {};
  var titleAlign = align ? {
    textAlign: align
  } : {};
  return _react2["default"].createElement('div', {
    style: [styles.wrapper, wrapperCustomStyle]
  }, _react2["default"].createElement('div', {
    style: [styles.title, titleCustomColor, titleAlign]
  }, title), _react2["default"].createElement('hr', {
    style: [styles.hr, hrAlign]
  }));
}

var component = (0, _radium2["default"])(SectionTitle);
exports["default"] = {
  component: component
};